<template>
  <div class="box" v-if="info">
    <FansText :str="interest"></FansText>
    <div class="fans">
        <div id="fanslike" ref="chart"></div>
    </div>
  </div>
  <div v-else class="chart">
    <none-data :height="3.5" />
  </div>
</template>

<script>
import FansText from "@/components/FansText.vue";
export default {
  props: {
    info: { type: Object },
  },
  data() {
    return {};
  },
  components: { FansText },
  computed: {
    interest() {
      if (this.info) {
        const obj = this.info;
        if (obj && Array.isArray(obj)) return [];
        const topList = Object.entries(obj)
          .map(([name, value]) => ({ name, value: Number(value || 0) }))
          .sort((a, b) => b.value - a.value)
          .slice()
          .splice(0, 3); //排序取前4
        const interestname = topList
          .map((item) => item.name)
          .toString()
          .replace(/,/g, "、");
        return `${interestname}的粉丝居多，在${interestname}粉丝中具有优势`;
      }
    },
  },
  methods: {
    // 字体适配
FontChart(res) {
        //获取到屏幕的宽度
        var clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth; 
        if (!clientWidth) return; //报错拦截：
        let fontSize = 10 * (clientWidth / 1920);
        return res * fontSize;
      },
    drawChart() {
           const max = Object.entries(this.info)
          .map(([name, value]) => ({ name, value: Number(value || 0) }))
          .sort((a, b) => b.value - a.value)
          .slice()
          .splice(0, 1)[0].value*100;
          const data = []
        const indicator = Object.entries(this.info).map(([name, value]) => {
            data.push((value*100).toFixed(2))
            return ({ name: name, max: max.toFixed(2), })
        })

      echarts.init(document.getElementById('fanslike')).setOption({
        radar: {
        // shape: 'circle',
        name: {
            textStyle: {
                color: '#4D4D4D',
                fontSize:this.FontChart(4),
            }
        },
        splitArea:{
            show:true
        },
        radius:'60%',
        center: ['50%', '45%'],
        indicator,
    },
    series: [{
        name: '粉丝兴趣分布',
        type: 'radar',
        // areaStyle: {normal: {}},
        data: [
            {
                value: data,
                name: '粉丝兴趣分布'
            }
        ],
        areaStyle: {
            color:'rgba(184,232,255,0.8)'

        },
        lineStyle:{
            color:'#009EFF',
            width:1
        },
        label:{
            show:true,
            position:'top',
            fontSize:this.FontChart(5),
            color:'#71aaf8',
        },
        symbol:"circle",
        symbolSize:1,
        showAllSymbol:false,
        itemStyle:{
            color:"white",
            borderColor:"#00aaff",
            borderWidth:1
        }
    }]
      });
    },
  },
  mounted() {
    if(this.info && this.info !== {}) {
        this.drawChart();
    }
  },
};
</script>

<style scoped lang="less">
.chart{
  width: 100%;
  height: 255px;
  justify-content: center;
  align-items: center;
  display: flex;
}
#fanslike {
    width: 220px;
    height: 220px;
}
.fans {
  display: flex;
  justify-content: center;
  width: 100%;
}
</style>
